function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgDuration(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 12,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    clipRule: "evenodd",
    d: "M10.959 8.207a4.98 4.98 0 11-9.96 0 4.98 4.98 0 019.96 0z",
    stroke: props.color,
    strokeWidth: 0.94,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M4.407 1.131h3.145M9.5 4.687l.935-.935M5.455 3.228V1.13h1.049v2.097M10.173 3.49l.524.524M5.98 8.207L3.62 5.848",
    stroke: props.color,
    strokeWidth: 0.94,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

export default SvgDuration;